export const EXPENSE_CATEGORY_TABS = [
  { value: undefined, label: "All" },
  { value: "team_current", label: "Team" },
  { value: "subscriptions", label: "Subscriptions" },
  { value: "other_costs", label: "Other Costs" },
];

export const EXPENSE_CATEGORY_OPTIONS = [
  { value: "team_current", label: "Team" },
  { value: "subscriptions", label: "Subscriptions" },
  { value: "other_costs", label: "Other Costs" },
];

export const EXPENSE_TYPE = {
  FIXED: "fixed",
  VARIABLE: "variable",
};

export const EXPENSE_TYPE_OPTIONS = [
  { value: EXPENSE_TYPE.FIXED, label: "Recurring Monthly" },
  { value: EXPENSE_TYPE.VARIABLE, label: "One-time Expense" },
];

export const EXPENSE_TYPE_LABELS = {
  [EXPENSE_TYPE.FIXED]: "Recurring Monthly",
  [EXPENSE_TYPE.VARIABLE]: "One-time Expense",
};

export const EXPENSE_SUBCATEGORIES = {
  team_current: [
    { value: "editors_thumbnails", label: "Editors / Thumbnails" },
    { value: "videographer", label: "Videographer" },
  ],
  subscriptions: [
    { value: "ghl", label: "GHL" },
    { value: "skool", label: "Skool" },
    { value: "heygen", label: "HeyGen" },
    { value: "manychat", label: "ManyChat" },
    { value: "claude", label: "Claude" },
    { value: "google_drive", label: "Google Drive" },
    { value: "simyo", label: "Simyo" },
    { value: "ig_verification", label: "IG Verification" },
  ],
  other_costs: [
    { value: "ad_expense", label: "Ad Expense" },
    { value: "field_access", label: "Field Access" },
  ],
};

export const EXPENSE_CATEGORY_META = [
  { key: "team_current", label: "Team", color: "#4F46E5" },
  { key: "subscriptions", label: "Subscriptions", color: "#10B981" },
  { key: "other_costs", label: "Other Costs", color: "#F59E0B" },
];

export const formatExpenseLabel = (value) =>
  value
    ? value
        .split("_")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ")
    : "-";

export const getSubcategoryLabel = (category, subcategory) => {
  if (!subcategory) return "-";
  const match = EXPENSE_SUBCATEGORIES[category]?.find((s) => s.value === subcategory);
  return match?.label ?? formatExpenseLabel(subcategory);
};
